import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useOptionalAssignmentService } from 'src/apis/assignment-service/use-optional-assignment-service';
import { usePublicStorageOffers } from 'src/apis/storage/use-public-storage-offers';
import { useStorageOfferDetails } from 'src/apis/storage/use-storage-offer-details';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { storageOffersListDefaultParams } from 'src/pages/storage/offers-new/utils';

const Page = lazy(() => import('./page'));

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageOfferDetails: FC<Props> = ({ storageServiceRoot }) => {
  const { offerId } = useParams<{ offerId: string }>();

  const params = useMemo(() => storageOffersListDefaultParams, []);

  const assignmentService = useOptionalAssignmentService();

  const storageOffers = usePublicStorageOffers({
    storageServiceRoot,
    params,
  });

  const storageOfferDetails = useStorageOfferDetails({
    storageOffers,
    offerId,
  });

  if (
    (assignmentService.response === null && assignmentService.error === null) ||
    !storageOfferDetails?.response ||
    storageOffers.response === null
  ) {
    return <PageSpinner />;
  }

  return (
    <Page
      storageServiceRoot={storageServiceRoot}
      storageOfferDetails={storageOfferDetails}
      storageOffers={storageOffers}
      assignmentService={
        assignmentService.response ? assignmentService : undefined
      }
    />
  );
};
